import { render } from "./KoruMap.vue?vue&type=template&id=00031bf4&ts=true"
import script from "./KoruMap.vue?vue&type=script&lang=ts"
export * from "./KoruMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__